'use strict';

/* Filters */

angular.module('Syrinscape.filters', [])
	.filter('interpolate', ['version', function(version) {
		return function(text) {
			return String(text).replace(/\%VERSION\%/mg, version);
		};
	}])
	.filter('to10thPercent', function () {
		return function (value) {
			return Math.floor(value * 10) * 10 || 0;
		};
	})
	.filter('maskSizeClamp', function() {
		return function(value) {
			return Math.round((100 - (value * 100)) / 10) * 10;
		};
	})
	.filter('rawHtml', ['$sce', function($sce){
		return function(val) {
			return $sce.trustAsHtml(val);
		};
	}]);



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/filters.js